module.exports = __webpack_public_path__ + "img/client17.6d7d02b6.svg";